<template>
    <div class="min-h-screen bg-primary-bg">
      <slot />
    </div>
  </template>
  